/** @return {string} */
export default function generatePassword() {
  let password = '';
  const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';

  for (let i = 0; i < 8; i += 1) {
    const randomIndex = Math.floor(Math.random() * (characters.length - 1));

    password += characters[randomIndex];
  }

  return password;
}
